// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.enterNameComponent {
    display: flex;
    align-items: center;
    flex-direction: column;
}

.signInText {
    font-family: "Poppins", sans-serif;
    font-weight: 600px;
    font-size: 24px;
    line-height: 32px;
}

.nameInputContainer {
    margin-top: 52px;
    display: flex;
    flex-direction: column;
    gap: 28px;
}

.NextBtnContainer {
    margin-top: 22px;
}

.rectangleBoxContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
    margin-top: 20px;
}

.rectangleBox {
    width: 52px;
    height: 8px;
    background-color: white;
    border-radius: 51px;
}

.coloured {
    background-color: #48D1CC;
}

@media (max-width: 1640px) {
    .signInText {
        font-size: 22px;
    }
    .rectangleBoxContainer {
        gap: 9px;
        margin-bottom: 18px;
        margin-top: 18px;
    }
    .rectangleBox {
        width: 48px;
        height: 7px;
        border-radius: 48px;
    }
    .nameInputContainer {
        margin-top: 48px;
        gap: 24px;
    }
}

@media (max-width: 1440px) {
    .signInText {
        font-size: 20px;
    }
    .rectangleBoxContainer {
        gap: 8px;
        margin-bottom: 16px;
        margin-top: 16px;
    }
    .rectangleBox {
        width: 42px;
        height: 7px;
        border-radius: 42px;
    }
    .nameInputContainer {
        margin-top: 30px;
        gap: 22px;
    }
}

@media (max-width: 1280px) {
    .signInText {
        font-size: 18px;
    }
    .rectangleBoxContainer {
        gap: 7px;
        margin-bottom: 14px;
        margin-top: 14px;
    }
    .rectangleBox {
        width: 40px;
        height: 7px;
        border-radius: 40px;
    }
    .nameInputContainer {
        margin-top: 20px;
        gap: 12px;
    }
}

@media (max-width: 1024px) {
    .signInText {
        font-size: 16px;
    }
    .rectangleBoxContainer {
        gap: 6px;
        margin-bottom: 12px;
        margin-top: 12px;
    }
    .rectangleBox {
        width: 38px;
        height: 6px;
        border-radius: 38px;
    }
    .nameInputContainer {
        margin-top: 10px;
        gap: 6px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/SignUpFlow/EnterName/EnterName.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,QAAQ;QACR,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,gBAAgB;QAChB,SAAS;IACb;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,QAAQ;QACR,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,gBAAgB;QAChB,SAAS;IACb;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,QAAQ;QACR,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,gBAAgB;QAChB,SAAS;IACb;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,QAAQ;QACR,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,gBAAgB;QAChB,QAAQ;IACZ;AACJ","sourcesContent":[".enterNameComponent {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n}\n\n.signInText {\n    font-family: \"Poppins\", sans-serif;\n    font-weight: 600px;\n    font-size: 24px;\n    line-height: 32px;\n}\n\n.nameInputContainer {\n    margin-top: 52px;\n    display: flex;\n    flex-direction: column;\n    gap: 28px;\n}\n\n.NextBtnContainer {\n    margin-top: 22px;\n}\n\n.rectangleBoxContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 20px;\n    margin-top: 20px;\n}\n\n.rectangleBox {\n    width: 52px;\n    height: 8px;\n    background-color: white;\n    border-radius: 51px;\n}\n\n.coloured {\n    background-color: #48D1CC;\n}\n\n@media (max-width: 1640px) {\n    .signInText {\n        font-size: 22px;\n    }\n    .rectangleBoxContainer {\n        gap: 9px;\n        margin-bottom: 18px;\n        margin-top: 18px;\n    }\n    .rectangleBox {\n        width: 48px;\n        height: 7px;\n        border-radius: 48px;\n    }\n    .nameInputContainer {\n        margin-top: 48px;\n        gap: 24px;\n    }\n}\n\n@media (max-width: 1440px) {\n    .signInText {\n        font-size: 20px;\n    }\n    .rectangleBoxContainer {\n        gap: 8px;\n        margin-bottom: 16px;\n        margin-top: 16px;\n    }\n    .rectangleBox {\n        width: 42px;\n        height: 7px;\n        border-radius: 42px;\n    }\n    .nameInputContainer {\n        margin-top: 30px;\n        gap: 22px;\n    }\n}\n\n@media (max-width: 1280px) {\n    .signInText {\n        font-size: 18px;\n    }\n    .rectangleBoxContainer {\n        gap: 7px;\n        margin-bottom: 14px;\n        margin-top: 14px;\n    }\n    .rectangleBox {\n        width: 40px;\n        height: 7px;\n        border-radius: 40px;\n    }\n    .nameInputContainer {\n        margin-top: 20px;\n        gap: 12px;\n    }\n}\n\n@media (max-width: 1024px) {\n    .signInText {\n        font-size: 16px;\n    }\n    .rectangleBoxContainer {\n        gap: 6px;\n        margin-bottom: 12px;\n        margin-top: 12px;\n    }\n    .rectangleBox {\n        width: 38px;\n        height: 6px;\n        border-radius: 38px;\n    }\n    .nameInputContainer {\n        margin-top: 10px;\n        gap: 6px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
